import { render, staticRenderFns } from "./wuyeRegister.vue?vue&type=template&id=7fcfc334&scoped=true"
import script from "./wuyeRegister.vue?vue&type=script&lang=js"
export * from "./wuyeRegister.vue?vue&type=script&lang=js"
import style0 from "./wuyeRegister.vue?vue&type=style&index=0&id=7fcfc334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcfc334",
  null
  
)

export default component.exports